<template>
  <div class="lung-effect">
    <md-field>
      <md-select
        v-close-on-zoom
        class="orientation-select"
        :value="state.effect.orientation"
        placeholder="all sides"
        :disabled="readonly"
        :md-attach-to-parent="true"
        @input="orientation => selectOrientation(orientation)"
      >
        <md-option class="orientation-option">all sides</md-option>
        <md-option value="FRONT" class="orientation-option">front</md-option>
        <md-option value="BACK" class="orientation-option">back</md-option>
      </md-select>
      <md-select
        v-close-on-zoom
        class="spot-select"
        :value="state.effect.spot"
        placeholder="all spots"
        :disabled="!lungSoundSpots.length || readonly"
        :md-attach-to-parent="true"
        @input="spot => selectSpot(spot)"
      >
        <md-option class="spot-option">All</md-option>
        <md-option
          v-for="spot in lungSoundSpots"
          :key="spot"
          :value="spot"
          class="spot-option"
        >
          {{ state.effect.orientation === 'BACK' ? spot + 1 + 4 : spot + 1 }}
        </md-option>
      </md-select>

      <div class="sound-volume-container">
        <md-field>
          <md-select
            v-close-on-zoom
            :value="state.effect.value"
            placeholder="Sound"
            class="lung-sound-select"
            :disabled="readonly"
            @input="lungSound => updateSound(lungSound)"
          >
            <md-option
              v-for="lungSound in lungSounds"
              :key="lungSound.id"
              :value="lungSound.resourceName"
            >
              {{ lungSound.resourceName.replace(/_/g, ' ').replace(/\..+/, '') | startCase }}
            </md-option>
          </md-select>
        </md-field>
        <!-- The event is to prevent volume slider from moving the node with it -->
        <volume-slider
          :value="!isUndefined(state.effect.volume) ? state.effect.volume : 1"
          class="volume-slider"
          @pointerdown.native.stop
          @input="updateVolume"
        />
      </div>
    </md-field>
  </div>
</template>

<script>
import startCase from 'lodash/startCase';
import range from 'lodash/range';
import isUndefined from 'lodash/isUndefined';

import VolumeSlider from '~lib/common/components/VolumeSlider';

export default {
  name: 'lung-effect',
  filters: {
    startCase,
  },
  components: {
    VolumeSlider,
  },
  props: [
    'sounds',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        effect: {
          value: 'NORMAL',
          volume: 1,
          orientation: null,
        },
      },
      lungSounds: this.sounds.filter(s => s.category === 'breath'),
    };
  },
  computed: {
    lungSoundSpots() {
      const { orientation } = this.state.effect;
      if (orientation === 'FRONT') {
        return range(4);
      } else if (orientation === 'BACK') {
        return range(6);
      }
      return [];
    },
  },
  mounted() {
    this.state.effect = {
      ...this.state.effect,
      ...(this.getData(this.ikey) || {}),
    };
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateSound(lungSoundKey) {
      this.state.effect.value = lungSoundKey;
      this.update();
    },
    updateVolume(volume) {
      this.state.effect.volume = volume;
      this.update();
    },
    selectSpot(spot) {
      this.state.effect.spot = spot;
      this.update();
    },
    selectOrientation(orientation) {
      const { effect } = this.state;
      effect.orientation = orientation;
      // Only keep the applicable spots
      effect.spot = this.lungSoundSpots.includes(effect.spot) ? effect.spot : null;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'LUNG_SOUND',
        ...this.state.effect,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
    isUndefined,
  },
};
</script>

<style scoped>
.lung-select {
  width: 130px;
}

.lung-effect {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.md-field {
  align-items: flex-start;
}

.duration-input {
  width: 125px;
}
.sound-volume-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}

.volume-slider {
  width: 120px;
  margin-right: 10px;
}
</style>
